import { inject } from '@angular/core';
import { type ResolveFn } from '@angular/router';
import { catchError, of } from 'rxjs';

import { OnboardingApiService } from '@shared/services/onboarding-api.service';
import type { CountryOption } from '@shared/interfaces/opportunity.interface';

export type PepDataInitData = CountryOption[];

export const pepDataResolver: ResolveFn<PepDataInitData> = () => {
  const onboardingApi = inject(OnboardingApiService);
  return onboardingApi.getCountries().pipe(catchError(() => of([])));
};
